export default __webpack_public_path__ + "static/media/logo-dark.f2ffa12f.svg";